export default __webpack_public_path__ + "static/accents-whiteboard-light-0940c587d5c36d1bb051dbffda28b5e0.png";